module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kca_m.584990ec55396cd18d0ee4f734da6900.png";